import AcessControl from ".";

export const accessControlRoutes = [
  {
    path: "/accessControls",
    element: <AcessControl />,
  },
];
